import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import {
  Label,
  Button,
  GridRow,
  GridColumn,
  GridContainer,
  Ripple,
  Toastr,
  Img,
  Utils,
} from "arv-reactcomponents";
import { PasswordInput } from "../../Login";
import { blackboltConfig, MYACCOUNTPAGE, Endpoints } from "npmlinks-constants";

const {
  CHANGE_PASSWORD: {
    currentPasswordText,
    newPasswordText,
    MISMATCH_ERROR_MSG,
    SUBMIT,
    confirmPasswordText,
    title,
  },
} = MYACCOUNTPAGE;

@inject("MyAccountStore")
@observer
class ChangePassword extends Component {
  constructor() {
    super();
    this.state = {
      errorMsg: "",
      isShowLoader: false,
    };
    this.changePassword = this.changePassword.bind(this);
    this.disablePaste = this.disablePaste.bind(this);
  }

  get validateAllFields() {
    if (
      this.currentPasswordField &&
      this.passwordFieldNew &&
      this.passwordFieldConfirm &&
      this.currentPasswordField.state.isPasswordInputValid &&
      this.passwordFieldNew.state.isPasswordInputValid &&
      this.passwordFieldConfirm.state.isPasswordInputValid
    ) {
      return true;
    }
    return false;
  }

  changePassword() {
    if (
      !this.currentPasswordField.state.isPasswordInputValid ||
      !this.passwordFieldNew.state.isPasswordInputValid ||
      !this.passwordFieldConfirm.state.isPasswordInputValid
    ) {
      const invalidInput = document.querySelector("input.is-invalid");
      if (invalidInput) {
        invalidInput.focus();
      }
      this.setState({
        errorMsg: blackboltConfig.FILL_MANDATORY_FIELDS,
      });
    } else if (
      this.passwordFieldNew.state.password !==
      this.passwordFieldConfirm.state.password
    ) {
      this.setState({ errorMsg: MISMATCH_ERROR_MSG });
    } else {
      this.setState({ errorMsg: "", isShowLoader: true });
      this.props.MyAccountStore.changePasswordAction(
        this.currentPasswordField.state.password,
        this.passwordFieldNew.state.password,
      )
        .then(res => {
          if (res.data) {
            Toastr.showToastr({
              className: "nwc-toastr-list-success nw-toastr",
              message: blackboltConfig.CHANGE_INFO_SUCCESS,
              timeout: 3000,
            });
          }
          this.setState({ errorMsg: "", isShowLoader: false });
          this.props.closePasswordModal();
        })
        .catch(err => {
          let errorDetail = blackboltConfig.ERROR_MSG;
          if (
            err &&
            blackboltConfig.ERROR_CODE.includes(JSON.stringify(err.status))
          ) {
            errorDetail = err.errors[0].detail;
          }
          this.setState({ errorMsg: errorDetail, isShowLoader: false });
        });
    }
  }

  disablePaste(e) {
    e.preventDefault();
  }

  render() {
    const { isShowLoader } = this.state;
    return (
      <div>
        <h3 className="nw-changepwd-heading">{title}</h3>
        <GridContainer className="nw-changepwd-container">
          <GridRow className="nw-changepwd-field">
            <GridColumn>
              <Label className="nw-userinfo-label">{currentPasswordText}</Label>
              <PasswordInput.component
                className="nw-userinfo-inp nwc-inp-xs"
                parentClassName="nw-myaccount-pwd-input"
                placeholder="Enter Current Password"
                name="password"
                showErrorMsg={Utils.noop}
                ref={values => {
                  this.currentPasswordField = values;
                }}
              />
            </GridColumn>
          </GridRow>
          <GridRow className="nw-changepwd-field">
            <GridColumn>
              <Label className="nw-userinfo-label">{newPasswordText}</Label>
              <PasswordInput.component
                className="nw-userinfo-inp nwc-inp-xs"
                parentClassName="nw-myaccount-pwd-input"
                placeholder="Enter New Password"
                name="newPassword"
                showErrorMsg={Utils.noop}
                minLength={8}
                ref={values => {
                  this.passwordFieldNew = values;
                }}
              />
            </GridColumn>
          </GridRow>
          <GridRow className="nw-changepwd-field">
            <GridColumn>
              <Label className="nw-userinfo-label">{confirmPasswordText}</Label>
              <PasswordInput.component
                className="nw-userinfo-inp nwc-inp-xs"
                parentClassName="nw-myaccount-pwd-input"
                placeholder="Confirm Password"
                name="confirmPassword"
                showErrorMsg={Utils.noop}
                minLength={8}
                onPaste={this.disablePaste}
                ref={values => {
                  this.passwordFieldConfirm = values;
                }}
              />
            </GridColumn>
          </GridRow>
        </GridContainer>
        <Ripple className="nwc-ripple-light">
          <Button
            type="submit"
            className="nwc-btn-primary nw-login-btn nw-grgt-submitbtn"
            onClick={this.changePassword}
          >
            {SUBMIT}
            {isShowLoader && (
              <div className="nw-login-loader">
                <Img
                  className="nw-loader"
                  src={Endpoints.LOADER}
                  alt="loader"
                />
              </div>
            )}
          </Button>
        </Ripple>
        <div className="nw-login-error">{this.state.errorMsg}</div>
      </div>
    );
  }
}

ChangePassword.wrappedComponent.propTypes = {
  closePasswordModal: PropTypes.func.isRequired,
  MyAccountStore: PropTypes.shape({
    changePasswordAction: PropTypes.func,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("MyAccountStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ChangePassword.wrappedComponent,
  component: ChangePassword,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/ChangePassword/index.js